import React from 'react';

const IcColor = ({ fill = '#ADADAD' }: { fill?: string }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='33' height='37' viewBox='0 0 33 37' fill='none'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M28.7917 23.0332C28.7917 23.0332 32.9083 27.2399 32.9083 31.4166C32.9083 34.1766 30.6667 36.4166 27.9083 36.4166C25.1483 36.4166 22.9083 34.1766 22.9083 31.4166C22.9083 27.2399 27.0233 23.0332 27.0233 23.0332C27.5117 22.5449 28.3033 22.5449 28.7917 23.0332Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M27.26 20.0567L17.8317 29.485C16.66 30.6567 15.07 31.315 13.4133 31.315C11.755 31.315 10.165 30.6567 8.99333 29.485L1.92333 22.415C0.751659 21.2417 0.0916595 19.6517 0.0916595 17.995C0.0916595 16.3367 0.751659 14.7467 1.92333 13.575L12.5283 2.97001C13.0167 2.48168 13.8083 2.48168 14.2967 2.97001L27.26 15.9317C28.3983 17.0717 28.3983 18.9183 27.26 20.0567ZM25.4917 18.29C25.655 18.1267 25.655 17.8633 25.4917 17.7L13.4133 5.62168L3.69166 15.3433C2.98833 16.0467 2.59166 17 2.59166 17.995C2.59166 18.99 2.98833 19.9433 3.69166 20.6467L10.7617 27.7167C11.465 28.42 12.4183 28.815 13.4133 28.815C14.4067 28.815 15.3617 28.42 16.065 27.7167L25.4917 18.29Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.3167 4.98999C16.805 5.47832 16.805 6.26999 16.3167 6.75832C15.8283 7.24499 15.0367 7.24499 14.5483 6.75832L10.5083 2.71666C10.02 2.22999 10.02 1.43666 10.5083 0.94999C10.9967 0.461657 11.7883 0.461657 12.2767 0.94999L16.3167 4.98999Z'
        fill={fill}
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.34166 16.7449H26.8633C27.5533 16.7449 28.1133 17.3049 28.1133 17.9949C28.1133 18.7415 27.8283 19.4882 27.26 20.0565L17.8317 29.4849C16.66 30.6565 15.07 31.3149 13.4133 31.3149C11.755 31.3149 10.165 30.6565 8.99333 29.4849L1.92333 22.4149C0.751659 21.2415 0.0916595 19.6515 0.0916595 17.9949C0.0916595 17.3049 0.65166 16.7449 1.34166 16.7449Z'
        fill={fill}
      />
    </svg>
  );
};

export default IcColor;
